import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = {
  key: 1,
  class: "w-full"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white p-16"
}
const _hoisted_4 = { class: "text-sm text-gray-500" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col items-center justify-center gap-4 rounded-lg border border-gray-200 bg-white p-16"
}
const _hoisted_6 = { class: "text-sm text-red-600" }

import { ref } from 'vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import { Button } from '@/components/ui/button';
import Spinner from '@/components/ui/Spinner.vue';
import { defaultReportFarmIds, type ReportDateSelection } from '@/composables/inventory/inventoryReport';
import { useInventoryScope } from '@/composables/inventory/useInventoryScope';
import { useMedicineReport } from '@/plugins/store/actions/queries/inventory';
import type { MedicineReportRequestFarm } from '@/types';
import ReportResult from './ReportResult.vue';
import SelectDatesStep from './SelectDatesStep.vue';
import SelectFarmsStep from './SelectFarmsStep.vue';

type Step = 'farms' | 'dates' | 'report';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportWizard',
  setup(__props) {

const step = ref<Step>('farms');
const { selectedFarms } = useInventoryScope();
/** The first farms of the dashboard's selection are ticked when the wizard starts. */
const farmIds = ref<number[]>(defaultReportFarmIds(selectedFarms.value));
const dateSelection = ref<ReportDateSelection>({});

const { mutate: loadReport, reset: resetReport, data: report, isPending, isError } = useMedicineReport();

/** Asks for the report of the farms and days the steps collected. */
function show(farms: MedicineReportRequestFarm[]) {
    step.value = 'report';
    loadReport(farms);
}

function startOver() {
    step.value = 'farms';
    // Back to the same first farms a fresh wizard starts with, not the last report's.
    farmIds.value = defaultReportFarmIds(selectedFarms.value);
    dateSelection.value = {};
    resetReport();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (step.value !== 'report')
        ? (_openBlock(), _createBlock(MainViewCard, {
            key: 0,
            class: "max-w-4xl w-full px-4 py-4"
          }, {
            default: _withCtx(() => [
              (step.value === 'farms')
                ? (_openBlock(), _createBlock(SelectFarmsStep, {
                    key: 0,
                    value: farmIds.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((farmIds).value = $event)),
                    onNext: _cache[1] || (_cache[1] = ($event: any) => (step.value = 'dates'))
                  }, null, 8, ["value"]))
                : (_openBlock(), _createBlock(SelectDatesStep, {
                    key: 1,
                    value: dateSelection.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dateSelection).value = $event)),
                    "farm-ids": farmIds.value,
                    onBack: _cache[3] || (_cache[3] = ($event: any) => (step.value = 'farms')),
                    onNext: show
                  }, null, 8, ["value", "farm-ids"]))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(isPending))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(Spinner, { class: "h-10 w-10 animate-spin" }),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('views.health.inventory.report.computing')), 1)
                ]))
              : (_unref(isError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('views.health.inventory.report.reportError')), 1),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      onClick: startOver
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.health.inventory.report.startOver')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_unref(report))
                  ? (_openBlock(), _createBlock(ReportResult, {
                      key: 2,
                      farms: _unref(report),
                      onReset: startOver
                    }, null, 8, ["farms"]))
                  : _createCommentVNode("", true)
          ]))
    ])
  ]))
}
}

})